import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { TailwindButtonDirective } from '../../../components/button/tailwind-button.directive';
import { SettingsCardComponent } from '../settings-card/settings-card.component';
import { SessionStateService } from '../../../services/session-state.service';
import { filter } from 'rxjs/operators';
import { FirestoreOrga } from '@jessie/commons';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { FormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-subscription-settings',
    templateUrl: './subscription-settings.component.html',
    imports: [SettingsCardComponent, TailwindButtonDirective, FormsModule, AsyncPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriptionSettingsComponent implements OnInit {
  link = environment.customerPortalLink;
  suffix = '';
  isAdmin$ = this.sessionState.isAdmin();
  targetOrgaId$ = new BehaviorSubject<string>('');
  errorMessage$ = new BehaviorSubject<string>('');

  constructor(
    private sessionState: SessionStateService,
    @Inject(Functions) private functions: Functions
  ) {}

  async ngOnInit() {
    const orga = await firstValueFrom(
      this.sessionState.getOrga().pipe(filter((orga): orga is FirestoreOrga => !!orga))
    );
    const emailAddress = orga.data.subscription?.email ?? '';
    this.suffix = emailAddress ? '?prefilled_email=' + emailAddress : '';

    // Get admin status
    console.log('isAdmin', await this.isAdmin$);
  }

  async enableTestSubscription() {
    const orgaId = this.targetOrgaId$.value;
    if (!orgaId) {
      console.error('Please enter an Orga ID');
      return;
    }

    this.errorMessage$.next(''); // Clear any previous error
    const enableTestSubscription = httpsCallable(this.functions, 'enableTestSubscriptionHttp');

    try {
      const result = await enableTestSubscription({ orgaId });
      console.log('Test Subscription enabled:', result);
      this.targetOrgaId$.next(''); // Clear the input field after success
    } catch (error) {
      console.error('Error enabling test subscription:', error);
      this.errorMessage$.next(
        error instanceof Error
          ? error.message
          : 'An error occurred while enabling the test subscription'
      );
    }
  }
}
